import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import {
  TradeTripChargesComponentProperties,
  TradeTripChargesComponent
} from 'src/vendor/_components/vendor-trade-maintenance/_components/trade-trip-charges.component';
import { VendorViewModel, TradeViewModel, ExcludedZipViewModel } from '@models/Vendor';
import { searchZipCodes, saveExcludedZips, deleteExcludedZips, getTripCharges } from 'src/vendor/vendor.actions';
import { toggleModal } from '@common/components/common.actions';
import { ModalProps } from '@common/components';

interface TradeTripChargesProperties {
  readonly vendorVM: VendorViewModel;
  readonly currentTrade: TradeViewModel;
}

function mapStateToProps(
  state: AppState,
  ownProps: TradeTripChargesProperties
): Partial<TradeTripChargesComponentProperties> {
  return {
    vendorVM: ownProps.vendorVM,
    currentTrade: ownProps.currentTrade,
    zipCodes: state.vendor.zipCodes,
    tripCharges: state.vendor.tripCharges
  };
}

function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: TradeTripChargesProperties
): Partial<TradeTripChargesComponentProperties> {
  return {
    getTripCharges: (currentTrade: TradeViewModel) => {
      dispatch(getTripCharges(currentTrade.vendorId, currentTrade.tradeId));
    },
    zipCodeLookup: (vendorId: number, query: string, excludeZips?: boolean) => {
      return searchZipCodes(vendorId, query, excludeZips);
    },
    toggleModal: (modalProps?: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    saveTripCharges: async (currentTrade: TradeViewModel, excludedZips: Array<ExcludedZipViewModel>) => {
      dispatch(saveExcludedZips(currentTrade.tradeId, currentTrade.vendorId, excludedZips))
        .then(() => {
          dispatch(toggleModal());
          dispatch(getTripCharges(currentTrade.vendorId, currentTrade.tradeId));
          return Promise.resolve();
        })
        .catch(() => Promise.reject(''));
    },
    removeTripCharge: (item: ExcludedZipViewModel) => {
      dispatch(deleteExcludedZips(item.tradeId, item.vendorId, [item])).then(() => {
        dispatch(toggleModal());
        dispatch(getTripCharges(item.vendorId, item.tradeId!));
      });
    }
  };
}

export const TradeTripCharges = connect(
  mapStateToProps,
  mapDispatchToProps
)(TradeTripChargesComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/_components/trade-trip-charges.container.ts